import axios from "@/api/axiosAuthRequired.js"

const INSTAPRO_API_URL = process.env.INSTAPRO_API_URL
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getClassesByStatusAndOrder = async (status, order) => {
  try {
    const res = await axios.get(
      `${INSTAPRO_API_URL}api/v1/live-classes?status=${status}&sort_option=${order}`
    )
    return res.data.result.data
  } catch (error) {
    console.error(error)
    return []
  }
}

export const fetchClassById = async id => {
  try {
    const res = await axios.get(`${INSTAPRO_API_URL}api/v1/live-classes/${id}`)
    return res.data
  } catch (error) {
    console.error(error)
    return { result: null }
  }
}

export const fetchClasses = async ({ coachId, status, order, games, page }) => {
  try {
    let url = ""
    if (coachId) {
      url = `${INSTAPRO_API_URL}api/v1/coach/${coachId}/live-classes?status=${status}&sort_option=${order}`
    } else {
      url = `${INSTAPRO_API_URL}api/v1/live-classes?status=${status}&sort_option=${order}`
    }
    if (page) url += `&page=${page}`
    if (games && games.length > 0) {
      for (let i in games) {
        if (games[i].value) {
          url += `&games[${i}]=${games[i].value}`
        }
      }
    }
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.log(error)
    return error.message
  }
}

export const fetchLiveClassesByGameAndStatus = async () => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/grouped-by-game-and-status`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.log(error)
    return error.message
  }
}

export const getAvailableSchedulingTimeSlots = async (
  instaProAccessToken,
  game,
  date,
  exclusion
) => {
  try {
    let url = `${INSTAPRO_API_URL}api/v1/coach/live-classes/available-time-slots?date=${date}`
    if (game) {
      url += `&game_id=${game}`
    }
    if (exclusion) {
      url += `&live_class_id_exclusions[0]=${exclusion}`
    }
    const res = await axios.get(url, {
      headers: { Authorization: "Bearer " + instaProAccessToken },
    })
    return res.data.result
  } catch (error) {
    console.error(error)
    return []
  }
}

export const scheduleLiveClass = async (instaProAccessToken, newClass) => {
  try {
    const res = await axios.post(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes`,
      newClass,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
    return res.data.result
  } catch (error) {
    console.error(error)
    return error.message
  }
}

export const deleteLiveClass = async (instaProAccessToken, classId) => {
  try {
    await axios.delete(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes/${classId}`,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
  } catch (error) {
    console.error(error)
    return error.message
  }
}

export const updateLiveClass = async (
  instaProAccessToken,
  id,
  updatedClass
) => {
  try {
    await axios.put(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes/${id}`,
      updatedClass,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
  } catch (error) {
    console.error(error)
    return error.message
  }
}

export const fetchLiveClassesAsCoach = async (
  instaProAccessToken,
  status,
  order
) => {
  try {
    const res = await axios.get(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes?status=${status}&sort_option=${order}`,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
    return res.data.result.data
  } catch (error) {
    console.error(error)
    return []
  }
}

export const startLiveClass = async (instaProAccessToken, classId) => {
  try {
    await axios.put(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes/${classId}/start`,
      null,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
    return "started"
  } catch (error) {
    console.error(error)
    return error.message
  }
}

export const endLiveClass = async (instaProAccessToken, classId) => {
  try {
    await axios.put(
      `${INSTAPRO_API_URL}api/v1/coach/live-classes/${classId}/end`,
      null,
      { headers: { Authorization: "Bearer " + instaProAccessToken } }
    )
    return "started"
  } catch (error) {
    console.error(error)
    return error.message
  }
}

export const getPlaybackUrl = async publicId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.get(
      `${PROGUIDES_WEB_URL}api/v2/broadcasts/live-video/${publicId}/playback-url`,
      {
        headers: { Authorization: "Bearer " + clientCredentials },
      }
    )

    return res.data.url
  } catch (error) {
    console.error(error)
    return ""
  }
}

export const getRecordingPlaybackUrl = async publicId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.get(
      `${PROGUIDES_WEB_URL}api/v2/broadcasts/stream-recording/${publicId}/playback-url`,
      {
        headers: { Authorization: "Bearer " + clientCredentials },
      }
    )

    return res.data.url
  } catch (error) {
    console.error(error)
    return ""
  }
}

// for now the adapter is always twilio
export const createChatChannelUser = async (chatName, avatarImageUrl) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.post(
      `${PROGUIDES_WEB_URL}api/v2/user/broadcasts/chat/channel-user`,
      {
        adapter: "twilio",
        name: chatName,
        avatarImageUrl,
      },
      {
        headers: {
          Authorization: `Bearer ${clientCredentials}`,
        },
      }
    )
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

// for now the adapter is always twilio
export const addUserToChat = async (
  chatChannelExtPublicId,
  chatUserExtPublicId
) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.post(
      `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/add-channel-user`,
      {
        adapter: "twilio",
        chatChannelExtPublicId,
        chatUserExtPublicId,
      },
      {
        headers: {
          Authorization: `Bearer ${clientCredentials}`,
        },
      }
    )
    return res.data.accessToken
  } catch (error) {
    console.error(error)
    return ""
  }
}

export const banUserFromChat = async body => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/channel/ban-user`
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    alert(error.message)
    return error
  }
}

// export const getBanHistory = async (chatUserExtPublicId) => {
//   try {
//     const clientCredentials = localStorage.getItem("client_credentials")
//     const config = {
//       headers: {
//         Authorization: `Bearer ${clientCredentials}`,
//       },
//     }
//     const url = `${PROGUIDES_WEB_URL}api/v2/user/broadcasts/chat/ban-history?chatUserExtPublicId=${chatUserExtPublicId}`
//     const res = await axios.get(url, config)
//     return res.data
//   } catch (error) {
//     console.error(error)
//     return error
//   }
// }

export const getAvailableGames = async () => {
  try {
    const res = await axios.get(`${INSTAPRO_API_URL}api/v1/games`)
    return res.data
  } catch (error) {
    console.error(error)
    return ""
  }
}

export const trackLiveClassUserView = async ({
  classId,
  getInstaProAccessToken,
}) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/${classId}/log-view`
    let res = null
    if (getInstaProAccessToken) {
      res = await axios.post(url, null, {
        headers: { Authorization: "Bearer " + getInstaProAccessToken },
      })
    } else {
      res = await axios.post(url)
    }
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const checkUserFeedbackEligibility = async ({
  classId,
  getInstaProAccessToken,
}) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/${classId}/check-user-feedback-eligibility`
    const res = await axios.get(url, {
      headers: { Authorization: "Bearer " + getInstaProAccessToken },
    })
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const submitUserFeedback = async ({
  body,
  classId,
  getInstaProAccessToken,
}) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/${classId}/submit-user-feedback`
    await axios.post(url, body, {
      headers: { Authorization: "Bearer " + getInstaProAccessToken },
    })
  } catch (error) {
    console.error(error)
  }
}

export const getUserVote = async ({ classId, getInstaProAccessToken }) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/${classId}/user-vote`
    const res = await axios.get(url, {
      headers: { Authorization: "Bearer " + getInstaProAccessToken },
    })
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const submitUserVote = async ({
  classId,
  getInstaProAccessToken,
  body,
}) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/live-classes/${classId}/user-vote`
    await axios.post(url, body, {
      headers: { Authorization: "Bearer " + getInstaProAccessToken },
    })
  } catch (error) {
    console.error(error)
  }
}

export const checkChatroomMod = async chatUserExtPublicId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/user/is-mod?chatUserExtPublicId=${chatUserExtPublicId}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const isUserBanned = async (
  chatChannelExtPublicId,
  chatUserExtPublicId
) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/channel/is-user-banned?chatChannelExtPublicId=${chatChannelExtPublicId}&chatUserExtPublicId=${chatUserExtPublicId}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const deleteMessage = async body => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/channel/delete-message`
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getBannedUsersInChannel = async chatChannelExtPublicId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/broadcasts/chat/channel/list-banned-users?chatChannelExtPublicId=${chatChannelExtPublicId}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}



// WEBPACK FOOTER //
// ./src/api/live-classes.js